<template>
  <div
    class="animated-circular-progress"
    :style="{ '--completion': completion, '--background': background, '--color': color }"
  >
    <svg viewBox="0 0 100 100" class="animated-circular-progress__bar">
      <circle
        cx="50"
        cy="50"
        r="46"
        stroke-width="8"
        fill="none"
        class="animated-circular-progress__bar-circle--background"
      />
      <circle
        cx="50"
        cy="50"
        r="46"
        stroke-width="8"
        fill="none"
        stroke-dashoffset="0"
        stroke-dasharray="290 100000"
        :class="{
          'animated-circular-progress__bar-circle': true,
          'animated-circular-progress__bar-circle--warning': warning,
        }"
      />
    </svg>

    <div class="animated-circular-progress__content">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    completion: {
      type: Number,
      default: 0,
    },
    warning: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'rgba(255, 255, 255, 0.5)',
    },
    background: {
      type: String,
      default: 'rgba(0, 0, 0, 0)',
    },
  },
})
</script>

<style lang="postcss">
.animated-circular-progress {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.6rem;

  &__bar {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  &__bar-circle {
    stroke: var(--color);
    stroke-dashoffset: calc(290 - var(--completion) * 290);
    transform: rotate(-90deg);
    transform-origin: center;
    transition:
      stroke-dashoffset 1s linear,
      stroke 0.2s ease-out;

    &--warning {
      animation: pulse 0.5s infinite linear alternate;
    }
    &--background {
      stroke: var(--background);
    }
  }

  &__content {
    width: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

@keyframes pulse {
  from {
    stroke: var(--color);
  }
  to {
    stroke: rgba(255, 255, 255, 0);
  }
}
</style>
